import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { PipesModule } from '@core/pipes/pipes.module'

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillDateV1FieldComponent } from './fill-date-v1/fill-date-v1.component';
import { ViewDateV1FieldComponent } from './view-date-v1/view-date-v1.component';
import { SettingsDateV1FieldComponent } from './settings-date-v1/settings-date-v1.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        PipesModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillDateV1FieldComponent,
        ViewDateV1FieldComponent,
        SettingsDateV1FieldComponent
    ],
    exports: [
        FillDateV1FieldComponent,
        ViewDateV1FieldComponent,
        SettingsDateV1FieldComponent
    ],

})
export class CoreCustomFormsFieldDateV1FieldsModule { }
